import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useFullVariantByIdSsr } from '../../../../api/hooks/useFullVariantByIdSsr.hook';
import { useVariantDetailPage } from '../../../../api/hooks/useVariantDetailPage.hook';
import { VariantImageType } from '../../../../api/models/variant-image-type';
import { LinkVariants } from '../../../../utils/_enums/link-variants.enum';
import { TypographyVariantsEnum } from '../../../../utils/_enums/typeography-variants.enum';
import useFilterAttachments from '../../../../utils/_hooks/useFilterAttachments.hook';
import { Link } from '../../../_shared/link/link';
import { Typography } from '../../../_shared/typography/typography';
import styles from './legal-box.module.scss';

const LegalBox = (): JSX.Element => {
    const variant = useFullVariantByIdSsr();

    const legals = useFilterAttachments(
        VariantImageType.SALES_CONDITIONS,
        variant?.attachments
    );

    const data = useVariantDetailPage();

    if (legals && legals.length > 0) {
        return (
            <div className={styles['downloadable-file-box']}>
                <Typography
                    variant={TypographyVariantsEnum.HEADING4_BOLD}
                    className={styles['box-headline']}
                >
                    {data?.legal.headlineContent}
                </Typography>

                {legals.map((file) => (
                    <div className={styles['file-column']} key={file.id}>
                        <FontAwesomeIcon icon={faDownload}/>
                        <Link
                            href={file?.url ?? ''}
                            className={styles['instance-detail-link']}
                            variant={LinkVariants.STANDARD_LINK}
                            target="_blank"
                        >
                            {file?.name}
                        </Link>
                    </div>
                ))}

            </div>
        );
    } else {
        return <div />;
    }
};

export default LegalBox;
